import moment from 'moment';

export default (v) => {
    if(!v || !v.trim()){
        return '';
    }
    return moment(v, "YYYYMMDD").format('DD/MM/YY');
}



// WEBPACK FOOTER //
// ./resources/assets/js/filters/fecha-micro.js